import React, { FC, PropsWithChildren, ReactElement, memo } from 'react';

interface TernaryProps {
  condition: boolean;
  falseElement?: ReactElement | null;
  asChild?: boolean;
}

const Ternary: FC<PropsWithChildren<TernaryProps>> = memo(({
  condition,
  falseElement = null,
  asChild = false,
  children,
  ...props
}) => {
  const contentToRender = condition ? children : falseElement;

  if (asChild && React.isValidElement(contentToRender)) {
    return React.cloneElement(contentToRender, props);
  }

  return contentToRender;
});

export default Ternary;

Ternary.displayName = 'Ternary';
